<template>
  <div class="data-board">
    <div class="board-top">
      <div class="top-item" v-for="item in topItems" :key="item.label" @click="open(item)">
        <div class="top-num" :class="item.tone">{{ item.value }}<span v-if="item.suffix">{{ item.suffix }}</span></div>
        <div class="top-label">{{ item.label }}</div>
      </div>
    </div>
    <div class="board-metrics">
      <div class="board-grid">
        <div class="grid-item" v-for="item in midItems" :key="item.label" @click="open(item)">
          <div class="grid-label">{{ item.label }}</div>
          <div class="grid-value">{{ item.value }}<span class="grid-ratio" v-if="item.ratio">{{ item.ratio }}</span><span class="grid-unit" v-if="item.unit">{{ item.unit }}</span><i class="value-arrow" v-if="item.arrow"></i></div>
          <div class="grid-extra" v-if="item.extraLead">{{ item.extraLead }}<em>{{ item.extraTail }}</em></div>
          <div class="grid-extra" v-if="item.extra2Lead">{{ item.extra2Lead }}<em>{{ item.extra2Tail }}</em></div>
        </div>
      </div>
      <div class="board-grid">
        <div class="grid-item" v-for="item in bottomItems" :key="item.label" @click="open(item)">
          <div class="grid-label">{{ item.label }}</div>
          <div class="grid-value">{{ item.value }}<span class="grid-ratio" v-if="item.ratio">{{ item.ratio }}</span><span class="grid-unit" v-if="item.unit">{{ item.unit }}</span><i class="value-arrow" v-if="item.arrow"></i></div>
          <div class="grid-extra" v-if="item.extraLead">{{ item.extraLead }}<em>{{ item.extraTail }}</em></div>
          <div class="grid-extra" v-if="item.extra2Lead">{{ item.extra2Lead }}<em>{{ item.extra2Tail }}</em></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampDataBoard',
  props: {
    type: {
      type: String,
      default: 'director'
    },
    pbi: {
      type: Object,
      default () {
        return {}
      }
    },
    iep: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    // 顶栏按角色区分，后两格三种类型相同
    topItems () {
      const learner = {
        label: this.type === 'pd' ? '全部学员' : (this.type === 'origin' ? '外派学员' : '在营学员'),
        value: this.formatMetric(this.pbi.inCampLearnerCount),
        path: '/researchCamp/students'
      }
      const rows = [
        learner,
        { label: '进度正常学员', value: this.formatMetric(this.pbi.onTrackLearnerCount), tone: 'green', path: '/researchCamp/students', query: { progressStatus: 'NORMAL' } },
        { label: '未达标学员', value: this.formatMetric(this.pbi.notMetLearnerCount), tone: 'red', path: '/researchCamp/students', query: { progressStatus: 'NOT_MET' } }
      ]
      if (this.type === 'pd') {
        rows.unshift({ label: '负责中心数', value: this.formatMetric(this.pbi.responsibleCenterCount) })
      }
      return rows
    },
    // 中间四格：理论课、技能周期、考试、打卡
    midItems () {
      return [
        this.metric({ label: '理论课平均进度', value: this.formatMetric(this.iep.theoryCourseAverageProgress), suffix: '%' }),
        this.metric({ label: '技能进阶平均周期', value: this.formatMetric(this.pbi.avgSkillAdvancementCycle), suffix: '天' }),
        this.metric({ label: '考试通过人次', value: this.formatMetric(this.iep.examPassedOccurrenceCount), suffix: `/${this.formatMetric(this.iep.examTotalOccurrenceCount)}`, arrow: true, key: 'exam' }),
        this.metric({ label: '打卡平均进度', value: this.formatMetric(this.iep.checkinAverageProgress), suffix: '%' })
      ]
    },
    // 下面四格：模拟器、复盘、实践
    bottomItems () {
      return [
        this.metric({ label: '虚拟模拟器考核达标数', value: this.formatMetric(this.pbi.virtualSimulatorPassedCount), suffix: `/${this.formatMetric(this.pbi.virtualSimulatorTotalCount)}` }),
        this.metric({ label: '实体模拟器总数', value: this.formatMetric(this.pbi.physicalSimulatorPracticeCount), suffix: '次', extraLead: '人均', extraTail: `${this.formatMetric(this.pbi.physicalSimulatorPerCapita)}次`, extra2Lead: '达标率', extra2Tail: `${this.formatMetric(this.pbi.physicalSimulatorPassRate)}%` }),
        this.metric({ label: '复盘总数', value: this.formatMetric(this.pbi.caseReviewCount), suffix: '次', extraLead: '人均', extraTail: `${this.formatMetric(this.pbi.caseReviewPerCapita)}次` }),
        this.metric({ label: '实践总数', value: this.formatMetric(this.pbi.handsOnPracticeCaseCount), suffix: '次', extraLead: '人均', extraTail: `${this.formatMetric(this.pbi.handsOnPracticePerCapita)}次` })
      ]
    }
  },
  methods: {
    // 斜杠后面的数字跟主数字同色，次、天、% 这类单位单独上色
    metric (item) {
      const suffix = item.suffix ? String(item.suffix) : ''
      let ratio = ''
      let unit = suffix
      if (suffix.charAt(0) === '/') {
        const unitIndex = suffix.search(/[^\d./-]/)
        ratio = unitIndex === -1 ? suffix : suffix.slice(0, unitIndex)
        unit = unitIndex === -1 ? '' : suffix.slice(unitIndex)
      }
      return Object.assign({}, item, { ratio, unit })
    },
    formatMetric (value) {
      if (value === null || value === undefined || value === '') return '-'
      const numeric = Number(value)
      return Number.isFinite(numeric) && !Number.isInteger(numeric)
        ? String(Number(numeric.toFixed(2)))
        : String(value)
    },
    // 点击数据格交给外层处理
    open (item) {
      this.$emit('open', item)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.data-board {
  .camp-white-card();
  margin-top: 13px;
  padding-top: 18px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);

  &.is-from-pd {
    margin-top: 0;
  }

  .board-top {
    display: flex;
    text-align: center;
    padding: 0 14px;

    .top-item {
      flex: 1;
    }

    .top-num {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      color: @camp-text;

      &.green {
        color: @camp-green;
      }

      &.red {
        color: @camp-red;
      }
    }

    .top-label {
      margin-top: 4px;
      font-size: 10px;
      font-weight: 300;
      line-height: 16px;
      color: #564C47;
    }
  }

  .board-metrics {
    margin-top: 16px;
    padding: 10px;
    border-radius: 10px;
    background: #eb1700 url('../../../assets/images/researchCamp/ph_bg.png') no-repeat center / cover;
  }

  .board-grid {
    display: flex;
    gap: 8px;

    & + .board-grid {
      margin-top: 8px;
    }

    .grid-item {
      flex: 1;
      min-width: 0;
      min-height: 66px;
      padding: 8px 2px;
      border-radius: 8px;
      text-align: center;
      background: #fff;
      box-sizing: border-box;
    }

    .grid-label {
      font-size: 10px;
      font-weight: 400;
      line-height: 14px;
      color: #564C47;
    }

    .grid-value {
      margin-top: 4px;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #000;
    }

    .grid-ratio {
      font-size: 10px;
      color: #000;
    }

    .grid-unit {
      font-size: 10px;
      font-weight: 400;
      color: #333;
    }

    .value-arrow {
      display: inline-block;
      width: 4px;
      height: 4px;
      margin-left: 2px;
      border-top: 1px solid #A39992;
      border-right: 1px solid #A39992;
      transform: rotate(45deg);
      vertical-align: 1px;
    }

    .grid-extra {
      font-size: 10px;
      font-weight: 400;
      line-height: 14px;
      color: #000000cc;

      em {
        font-style: normal;
        font-size: 10px;
        font-weight: 400;
        color: #000000cc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampDataBoard.vue